import Button from "components/Button/Button";
import { usePasskeyLogin } from "hooks/usePasskeyLogin";

const PasskeyLoginButton = () => {
  const { loginWithPasskey, isLoading } = usePasskeyLogin();

  return (
    <div className="passkey-login-button">
      <Button
        text={isLoading ? "Checking Passkey..." : "Sign in with Passkey"}
        onClick={loginWithPasskey}
        disabled={isLoading}
        element='button'
        variant='outlined'
      />
    </div>
  );
};

export default PasskeyLoginButton;